<template>
  <!-- 弹窗右部分 -->
  <div class="popupRight">
    <a :href="popupHref">
      <img :src="popupImg" alt="">
    </a>
    <span id="popupNone">
      <p>{{ popup }}</p>
    </span>
  </div>
</template>

<script>
export default {
  name:'popupRight',
  data() {
    return {
      popup:'x',
      popupHref:'#',
      popupImg:'https://wapimages.oss-cn-beijing.aliyuncs.com/jiyue/pctanchuan.jpg'
    }
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang='less'>
/* 弹窗右部分 */
.popupRight {
  position: relative;
  span{
    position: absolute;
    top: -15px;
    right: -15px;
    p{
      font-size: 20px;
      padding: 5px 11px;
      background: #f00;
      color: #fff;
      line-height: 22px;
      border-radius: 45px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Popup/popupRight.vue